import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private apiUrl = environment.apiUrl+"api/users";

  constructor(private http: HttpClient) {}

  login(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post(`${this.apiUrl}/login`, credentials);
  }
    create(data:any): Observable<any> {
    return this.http.post(`${this.apiUrl}/`, data);
  }
   verifemail(data:any): Observable<any> {
       return this.http.post(`${this.apiUrl}/email`, data);
  }
    veriftoken(data:any): Observable<any> {
       return this.http.post(`${this.apiUrl}/veriftoken`, data);
  }

     createStation(data:any): Observable<any> {
       return this.http.post(`${this.apiUrl}/create_station`, data);
  }

}
